<nav class="navbar navbar-expand-lg navbar-dark {{bgClass}}" *transloco="let t; read: 'ime.core.navigation'">
  <div class="container-fluid">
    <div class="navbar-header">
      <button type="button" class="navbar-toggler" (click)="isCollapsed = !isCollapsed" aria-expanded="false">
        <span class="visually-hidden">Toggle navigation</span>
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#bars-3"></svg>
      </button>
      <a class="navbar-brand" [routerLink]="['/dashboard']">
        Metec - IME 5.0
        <small style="position: absolute; bottom: 1px; left: 80px; font-size: 55%;opacity: 0.4;">{{settings.AppVersion}}</small>
      </a>
    </div>

    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent" [(ngbCollapse)]="isCollapsed">
      <ul class="navbar-nav me-auto">
        <li class="nav-item dropdown" ngbDropdown [container]="null">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Konfigureerimine
          </a>
          <div class="dropdown-menu" ngbDropdownMenu>
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/order-header']">Pakkumised</a>
            <!--<a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/order-lines']">Tellimuse read</a>-->
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/order']">Tootmistellimused</a>
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/configuration']">Konfiguratsioonid</a>
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/standalone']">Konfigureeritavad tooted</a>
          </div>
        </li>
        <li class="nav-item dropdown" ngbDropdown [container]="null">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            IME
          </a>
          <div class="dropdown-menu" ngbDropdownMenu>
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/item']">Items</a>
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/item-template']">Templates</a>
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/item-groups']">Item groups</a>
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/ime']">IME</a>
            <a class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/resource']">Resources</a>
          </div>
        </li>
        <li class="nav-item dropdown" ngbDropdown [container]="null" [autoClose]="'outside'" #generalMenu="ngbDropdown">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Üldine
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
            <!--<a class="dropdown-item" href="#">Employees</a>-->
            <li><a (click)="generalMenu.close()" class="dropdown-item" ngbDropdownItem [routerLink]="['/manufacturing/process']">Processes</a></li>
            <li><a (click)="generalMenu.close()" class="dropdown-item" ngbDropdownItem [routerLink]="['/common/property']">Specs</a></li>
            <li><a (click)="generalMenu.close()" class="dropdown-item" ngbDropdownItem [routerLink]="['/common/classificator']">Classificators</a></li>
            <li><a (click)="generalMenu.close()" class="dropdown-item" ngbDropdownItem *ngIf="PRIVILEGES.EditUser | userHasPrivilege" [routerLink]="['/common/user']">Users</a></li>
            <li><a (click)="generalMenu.close()" class="dropdown-item" ngbDropdownItem [routerLink]="['/common/event']">Events</a></li>
            <li><a (click)="generalMenu.close()" class="dropdown-item" ngbDropdownItem [routerLink]="['/common/parameter']">Parameters</a></li>
            <li><a (click)="generalMenu.close()" class="dropdown-item" ngbDropdownItem [routerLink]="['/common/contact']">Contacts</a></li>
            <li><a (click)="generalMenu.close()" class="dropdown-item" ngbDropdownItem [routerLink]="['/help']">Help</a></li>
          </ul>
        </li>
        <li class="nav-item dropdown" ngbDropdown [container]="null" *ngIf="PRIVILEGES.EditLocalization | userHasPrivilege">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#flag">
            </svg>
            {{t('Localization')}}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
            <a class="dropdown-item" [routerLink]="['/common/localization']">{{t('Localizations')}}</a>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" href="#" (click)="addKeys()">
              {{t('Add keys')}}
            </button>
          </div>
        </li>
        <li class="nav-item dropdown" ngbDropdown [container]="null" [autoClose]="'outside'" #topMenuItem="ngbDropdown">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#bolt">
            </svg>
            Sync
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown" ngbDropdownMenu>
            <li>
              <button class="dropdown-item" ngbDropdownItem href="#" (click)="asprovaSync()">
                <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#bolt">
                </svg>
                Asprova Sync
              </button>
            </li>
            <ng-container *ngIf="user.IsAdmin">
              <li class="dropdown-divider"></li>
              <li>
                <button class="dropdown-item" ngbDropdownItem href="#" (click)="responseTest()">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#document-text">
                  </svg>
                  {{t('Response Test')}}
                </button>
              </li>
              <li>
                <button class="dropdown-item" ngbDropdownItem href="#" (click)="responseExTest()">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#document-text">
                  </svg>
                  {{t('Response ex Test')}}
                </button>
              </li>
              <li>
                <button class="dropdown-item" ngbDropdownItem href="#" (click)="progressMessagesTest()">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#document-text">
                  </svg>
                  {{t('Progress Messages Test')}}
                </button>
              </li>
              <li>
                <button class="dropdown-item" ngbDropdownItem href="#" (click)="progressMessagesForUserTest()">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#document-text">
                  </svg>
                  {{t('Progress Messages For User Test')}}
                </button>
              </li>
              <li>
                <button class="dropdown-item" ngbDropdownItem href="#" (click)="toastTest()">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#document-text">
                  </svg>
                  {{t('Toast test')}}
                </button>
              </li>
            </ng-container>
          </ul>
        </li>
      </ul>
      <new-global-search/>
      <help-button *transloco="let h" [key]="h('help.ime.components.global-search')"></help-button>
      <ul class="navbar-nav ms-auto">
        <li class="nav-item dropdown" ngbDropdown container="null" #settingsMenu="ngbDropdown" [autoClose]="'outside'">
          <a class="nav-link dropdown-toggle dropdown-toggle-without-arrow d-flex align-items-center h-100 px-2" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="pi pi-cog"></span>
          </a>
          <div class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown" ngbDropdownMenu>
            <a class="dropdown-item" ngbDropdownItem (click)="settingsMenu.close()" [routerLink]="'changelog'">Version: {{settings.AppVersion}}</a>
            <a class="dropdown-item" ngbDropdownItem (click)="resetBrowserCaches(); settingsMenu.close()">{{t('Tühjenda vahemälu')}}</a>
            <a class="dropdown-item" ngbDropdownItem (click)="resetAllCaches(); settingsMenu.close()" [routerLink]="['/dashboard']">{{t('Restart')}}</a>
            <a role="menuitem" ngbDropdown [container]="null" display="dynamic" [placement]="'left-top'">
              <a ngbDropdownToggle class="dropdown-item dropdown-toggle">
                {{t('Päringute kestuse logimine')}}
                <span class="caret"></span>
              </a>
              <ul ngbDropdownMenu class="dropdown-menu" role="menu">
                <li>
                  <a (click)="setLogTimingData(true); settingsMenu.close()" class="dropdown-item" ngbDropdownItem>{{t('On')}}</a>
                  <a (click)="setLogTimingData(false); settingsMenu.close()" class="dropdown-item" ngbDropdownItem>{{t('Off')}}</a>
                </li>
              </ul>
            </a>
          </div>
        </li>
        <li class="nav-item dropdown" ngbDropdown [container]="null">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle *ngIf="stateService.currentUser$ | async as user" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{user?.Fullname}}
          </a>
          <div class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown" ngbDropdownMenu>
            <a class="dropdown-item" ngbDropdownItem [ngClass]="{'active': stateService.isHelpModeActivated$ | async}" (click)="stateService.toggleHelpMode()" title="{{t('Show/Hide shortcuts to help topics')}}">
              <svg viewBox="0 0 16 16" class="icon text-info" inlineSVG="#question-mark-circle"></svg>
              {{t('Help mode')}}
            </a>
            <a class="dropdown-item" ngbDropdownItem (click)="authService.logout()">Välju</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
